import { pxToRem } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flex: {
      display: 'flex',
      flex: '1',
      paddingLeft: theme.spacing(1),
    },
    brdBtm: {
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider,
      padding: theme.spacing(1, 0),
      pageBreakInside: 'avoid',
    },
    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    labelCol: {
      width: '25%',
      marginRight: theme.spacing(3),
    },
    flexGrow: {
      flex: '1',
    },
    marginLeft: {
      margin: theme.spacing(0, 0, 0, 1),
    },
    marginBottom: {
      marginBottom: theme.spacing(1),
    },
    paddingLeftZero: {
      paddingLeft: theme.spacing(0),
    },
    marginTop: {
      marginTop: theme.spacing(1),
    },
    typographyFontSize: {
      fontSize: pxToRem(12),
      '& *': {
        fontSize: pxToRem(12),
      },
    },
    infoAlert: {
      alignItems: 'center',
      background: theme.palette.grey[100],
      color: theme.palette.text.secondary,
      borderColor: theme.palette.grey[300],
      '& .MuiAlert-action': {
        display: 'unset',
        minWidth: 'fit-content',
      },
    },
    bold: {
      fontWeight: 800,
      textTransform: 'uppercase',
    },
  }),
);

export default useStyles;
